import { useContext } from 'react'
import { Link } from 'react-router'
import { Tooltip, Typography } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid-pro'

import { AppContext } from '../../../../providers/app-provider'
import { getFormattedDateTime } from '../../../../utils/helpers'
import useSharedStyles from '../../../../utils/shared.styles'

const AlertsTableResponse = (cellParams: GridCellParams<DeviceAlertTableRow, DeviceAlertTableRow['response']>) => {
  const { tenantId } = useContext(AppContext)
  const classes = useSharedStyles
  const cellValue = cellParams.value

  if (!cellValue)
    return (
      <Typography
        variant="body1"
        sx={{
          color: 'text.disabled',
        }}
      >
        N/A
      </Typography>
    )

  let responseText = 'Responded'
  if (cellValue.note === 'ack') responseText = 'Acknowledged'
  if (cellValue.note === 'test') responseText = 'Ignored'
  if (cellValue.note === 'decline') responseText = 'Declined'

  const usersName = [cellValue.user.firstName, cellValue.user.lastName].filter((x) => x).join(' ')

  return (
    <div style={{ width: '100%' }}>
      <Tooltip
        title={`${responseText}${usersName ? ` by ${usersName}` : null} on ${getFormattedDateTime(
          cellValue.updatedAt,
          'UTC',
          'LLL. d, yyyy'
        )} at ${getFormattedDateTime(cellValue.updatedAt, 'UTC', "h:mm aa 'UTC'")}`}
      >
        <Typography variant="body2" sx={classes.overflowText}>
          {responseText}
          {usersName && (
            <>
              {' '}
              by{' '}
              <Link to={`/tenant/${tenantId}/people/${cellValue.user.id}`} className="fs-exclude">
                {usersName}
              </Link>
            </>
          )}
          <br />
          on {getFormattedDateTime(cellValue.updatedAt, 'UTC', 'LLL. d, yyyy')} at {getFormattedDateTime(cellValue.updatedAt, 'UTC', "h:mm aa 'UTC'")}
        </Typography>
      </Tooltip>
    </div>
  )
}

export default AlertsTableResponse
